module.exports = __webpack_public_path__ + "static/media/3.f3da330f.png";